"use strict";
function sortLists() {
    const lists = document.querySelectorAll('.spv-autoSortedList');
    lists.forEach(list => {
        const items = list.querySelectorAll('[data-sort-by]');
        const sortedItems = Array.from(items).sort((a, b) => {
            const aText = a.dataset.sortBy || '';
            const bText = b.dataset.sortBy || '';
            return aText.localeCompare(bText);
        });
        sortedItems.forEach(item => list.appendChild(item));
    });
}
window.addEventListener('DOMContentLoaded', () => {
    console.debug('DOMContentLoaded SORTED');
    sortLists();
});
//# sourceMappingURL=sorted.js.map